module.exports = __webpack_public_path__ + "media/images/admin/icons/cpu-3ea45c8b4d3f76fbaa7b1fe5d36d09af.svg";